import landingCityAnimation from "assets/animations/streetCity.json";
import Lottie from "lottie-react";
import React from "react";
import { useTranslation } from "react-i18next";

const CityAnimation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Lottie
      animationData={landingCityAnimation}
      className="city-animation"
      initialSegment={[35, 50]}
      role="img"
      aria-labelledby={
        t("10706") /* Pagamento de estacionamento com parquímetro inteligente */
      }
      title={
        t("10706") /* Pagamento de estacionamento com parquímetro inteligente */
      }
    />
  );
};

export default CityAnimation;
